import React, { memo } from 'react';
import PropTypes from 'prop-types';
import reactStringReplace from 'react-string-replace';
import { addIndex, pipe, map, reduce } from 'ramda';

import { Text } from './textWithLinks.styles';
import { getLinksMap } from '../../utils/links';
import { TextLink } from './textLink';

const TextWithLinksComponent = ({ children, textStyle, linkStyle }) => {
  const replaceLink = (text, { raw, component }) => reactStringReplace(text, raw, () => component);

  // eslint-disable-next-line react/prop-types
  const renderLink = ({ navigationParam, text, contentType }, index) => (
    <TextLink
      key={index}
      navigationParam={navigationParam}
      text={text}
      linkStyle={linkStyle}
      contentType={contentType}
    />
  );

  const renderTextWithLinks = () =>
    pipe(
      getLinksMap,
      addIndex(map)(({ params, raw }, index) => ({ raw, component: renderLink(params, index) })),
      reduce(replaceLink, children)
    )(children);

  return <Text style={textStyle}>{renderTextWithLinks()}</Text>;
};

TextWithLinksComponent.propTypes = {
  children: PropTypes.node,
  textStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  linkStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.array]),
};

export const TextWithLinks = memo(TextWithLinksComponent);
